import { useEffect, useState } from "react";

export const useTimeParser = () => {
    const [secondCoolDown, setSecondCoolDown] = useState(60);

    useEffect(() => {
        let handler = true;
        if (handler) {
            setInterval(() => {
                setSecondCoolDown((prev) => Math.max(prev - 1, 0));
            }, 1000);
        }
        return () => {
            handler = false;
        };
    }, []);

    const reset = () => {
        setSecondCoolDown(60);
    };

    return { secondCoolDown, reset };
};
